// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.history-item-date {
  color: #212529 !important;
  font-family: "Roboto", sans-serif;
  font-size: 13px;
}
.history-item-date strong {
  font-weight: 500;
}

.history-content {
  min-height: 50px;
  font-size: 0.9rem;
}`, "",{"version":3,"sources":["webpack://./src/app/common/submit/history/history.component.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,iCAAA;EACA,eAAA;AACJ;AAAI;EACI,gBAAA;AAER;;AACA;EACI,gBAAA;EACA,iBAAA;AAEJ","sourcesContent":[".history-item-date {\r\n    color: #212529 !important;\r\n    font-family: \"Roboto\", sans-serif;\r\n    font-size: 13px;\r\n    strong {\r\n        font-weight: 500;\r\n    }\r\n}\r\n.history-content {\r\n    min-height: 50px;\r\n    font-size: 0.9rem;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
